export const colors = {
  primary: '#3498db',
  primaryDark: '#2980b9',
  secondary: '#2ecc71',
  danger: '#e74c3c',
  warning: '#f39c12',
  dark: '#2c3e50',
  light: '#ecf0f1',
  white: '#ffffff',
  gray: '#95a5a6',
  lightGray: '#bdc3c7',
  background: '#f8f9fa',
  text: '#2c3e50',
  textLight: '#7f8c8d',
  border: '#dee2e6',
  success: '#27ae60',
  cardBackground: '#ffffff',
  shadow: 'rgba(0, 0, 0, 0.1)'
};